import { useState } from "react";
import { useLookupPagesQuery } from "../../stores/OkOkStore";
import type { QueryParameters } from "../../types/QueryParameters";
import type { Pages } from "../../types/Pages";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";



export default function PagesList(){
    const [params,setParams]=useState<QueryParameters>({page:0, order:'', reverse:0});
    
    const { data, error, isLoading } = useLookupPagesQuery(params);
    const {translate}=useTrads();
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse?? 0});
    }
    const setLookup=function(lookup:string){
        const l={"fulltext":lookup}
        setParams({...params,r:{...params.r,...(lookup && l)}});
    }
        return (
 
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <div>
                    <input type="text" placeholder="search" name="search" onChange={e => { setLookup(e.target.value)} } />
                </div>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table">
                <thead className="sticky-top">
                    <tr>
                        <th scope="col" data-sort="titre">
                            <div className="table-sort">
                                {translate('titre')}
                                <div className={(params.order=='titre')?((params.reverse)?'desc':'asc'):undefined}>
                                    <a className='up' onClick={()=>{ setOrder('titre',1); }} ><i className="bi"></i></a>
                                    <a className='down' onClick={()=>{ setOrder('titre',0); }} ><i className="bi"></i></a>
                                </div>
                            </div>
                            
                        </th>
                        <th scope="col">{translate('statut')}</th>

                        <th scope="col"></th>
                        
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((page:Pages) => (

                        <tr key={page.id}>
                            <td>{page.titre}</td>
                            <td>{page.statut}</td>

                            <td>
                                <div className="d-flex">
                                <NavLink to={`/pages/${page.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>

                                <NavLink to={`/pages/${page.id.toString()}/edit`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-pencil-fill"></i>
                                </NavLink>
                                </div>
                            </td>    
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}